import { useEffect } from "react";
import { useEditorContext } from "../EditorContext";

// Add this new plugin
export default function EditablePlugin({ editable }) {
	const { editor } = useEditorContext();

	useEffect(() => {
		editor.setEditable(editable);
	}, [editor, editable]);

	return null;
}
